export default "### What is a Harberger Tax?\n";